import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

export type DeadLetterBulkAction = 'resubmit' | 'remove';

@Component({
    selector: 'app-dead-letter-bulk-actions',
    templateUrl: './dead-letter-bulk-actions.component.html',
    styleUrls: ['./dead-letter-bulk-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadLetterBulkActionsComponent {
  @Input() selectedCount = 0;
  @Input() totalCount = 0;
  @Input() selectAll = false;
  @Input() actionInProgress: DeadLetterBulkAction | null = null;
  @Output() bulkActionClick = new EventEmitter<DeadLetterBulkAction>();

  get hasSelection(): boolean {
    return this.selectAll || this.selectedCount > 0;
  }

  onResubmitClick(): void {
    this.bulkActionClick.emit('resubmit');
  }

  onRemoveClick(): void {
    this.bulkActionClick.emit('remove');
  }

}
